import React from 'react';

interface VisualizerProps {
  isActive: boolean;
  color?: string;
}

const Visualizer: React.FC<VisualizerProps> = ({ isActive, color = '#10b981' }) => {
  // Generate a symmetrical set of bars for a "waveform" look
  const bars = [1, 2, 3, 4, 5, 4, 3, 2, 1];

  return (
    <div className="flex items-center justify-center gap-1.5 h-12">
      {bars.map((heightMultiplier, i) => (
        <div
          key={i}
          className={`w-1.5 rounded-full transition-all duration-500 ease-in-out`}
          style={{
            backgroundColor: color,
            height: isActive ? `${heightMultiplier * 20}%` : '4px',
            opacity: isActive ? 1 : 0.2,
            animation: isActive ? `equalizer 1s ease-in-out infinite` : 'none',
            animationDelay: `${i * 0.1}s`
          }}
        />
      ))}
      <style>{`
        @keyframes equalizer {
          0%, 100% { transform: scaleY(1); }
          50% { transform: scaleY(1.5); }
        }
      `}</style>
    </div>
  );
};

export default Visualizer;